import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-live-casino-details',
  templateUrl: './live-casino-details.component.html',
  styleUrls: ['./live-casino-details.component.scss']
})
export class LiveCasinoDetailsComponent implements OnInit {

  @Input() game;
  @Input() liveGameDetails;
  
  constructor() { }

  ngOnInit(): void {
  }

}
